export default __webpack_public_path__ + "static/media/Kpjfullheading.82297b26.png";